var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 59,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ED0006",
  fillRule: "evenodd",
  d: "M29.474 28.968a11.23 11.23 0 0 1-7.369 2.749c-6.273 0-11.36-5.151-11.36-11.505s5.087-11.505 11.36-11.505a11.23 11.23 0 0 1 7.369 2.748 11.23 11.23 0 0 1 7.368-2.748c6.274 0 11.36 5.15 11.36 11.505 0 6.354-5.086 11.505-11.36 11.505a11.23 11.23 0 0 1-7.368-2.749",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9A000",
  fillRule: "evenodd",
  d: "M29.474 28.968a11.54 11.54 0 0 0 3.99-8.756 11.54 11.54 0 0 0-3.99-8.757 11.23 11.23 0 0 1 7.368-2.748c6.274 0 11.36 5.15 11.36 11.505 0 6.354-5.086 11.505-11.36 11.505a11.23 11.23 0 0 1-7.368-2.749",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5E00",
  fillRule: "evenodd",
  d: "M29.474 28.968a11.54 11.54 0 0 0 3.99-8.756 11.54 11.54 0 0 0-3.99-8.757 11.54 11.54 0 0 0-3.991 8.757 11.54 11.54 0 0 0 3.99 8.756",
  clipRule: "evenodd"
})));
export { SvgMastercard as ReactComponent };
export default __webpack_public_path__ + "Mastercard.234d5fbc.svg";